import React from 'react';

const SettingsPage = React.lazy(() => import('./SettingsPage'));

const SettingsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/settings',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SettingsPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default SettingsConfig;
